<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div>
            <loading
                :active.sync="loading"
                :can-cancel="false"
                :is-full-page="true"
            ></loading>
        </div>
        <b-row v-if="(!tienePti && !existeRechazoDesentralizado ) || idCitaPaciente == null">
            <b-col>
                <h3 v-if="!tienePti && !existeRechazoDesentralizado ">
                   El paciente ya cuenta con una solicitud de Hdx.
                </h3>
              <p v-if="idCitaPaciente == null ">
                   No se encuentra la sesión del paciente,Sí el paciente si cuenta con una sesión por favor vuelva a ingresar a través del dashboard.
                </p>
            </b-col>
        </b-row>
        <div v-else class="m-2" style="height: 91vh;">
            <div align="center" v-if="existeRechazoDesentralizado">
                <span style="color: red; font-weight: bold;" :title="idPtiRechazo">Pti rechazado</span>
            </div>
            <div align="center" v-if="borradorExistente && !activoEnDiagnocat">
                <span style="color: orange; font-weight: bold;">Auxiliares de diagnóstico incompletos</span>
            </div>
            <div class="container-nombre" v-if="contraerCard">
                <div class="row-nombre d-flex justify-content-center align-items-center">
                <div>
                    <div class="nombre-completo-paciente mr-3">Motivo de la cita:</div>
                </div>
                <div v-if="tagmotivocitaDatosArrayOriginal.length != 0">
                    <modificar-tag-motivo-cita
                        :idDenticion="id_denticion"
                        :idSesion="idSesionSeleccionada"
                        :cambioTag="cambioTag"
                        @TagMotivoSeleccionado= "tagMotivoSeleccionado = $event"
                        :tagSeleccionadoEnLaCitaArray="tagSeleccionadoEnLaCitaArray"
                        :tagmotivocitaDatosArrayOriginal="tagmotivocitaDatosArrayOriginal"
                    ></modificar-tag-motivo-cita>
                </div>
                </div>
            </div>
            <div class="d-flex justify-content-between p-2">
                <p class="tituloHC">Diagnóstico</p>
                <div>
                    <b-row>
                        <b-col>
                            <DiagnocatModal
                                v-if="activoEnDiagnocat"
                                :idPaciente="idPaciente"
                                :idClinica="formulario.idClinica"
                                @agregar-odontograma="recibirOdontograma"
                                :idTagMotivoCita="formulario.idTagMotivoCita"
                                :idDenticion="id_denticion"
                                :idSesion="idSesionSeleccionada"
                                :accionesDiagnocat="accionesDiagnocat"
                            ></DiagnocatModal>
                        </b-col>
                        <b-col>
                            <!-- <em class="boton_herramientas sombraModales"></em> -->
                            <herramientasModal :idPacienteExp="idPaciente"></herramientasModal>
                        </b-col>
                        <b-col>
                            <observacionesCita :idCita="idCitaPaciente"></observacionesCita>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div align="right" v-if="!multiplesTrts" style="height: 77%;">
                <b-row>
                    <b-col cols="4" style="height: 100%;">
                        <b-row>
                            <b-col cols="10">
                                <!-- <nuevoOdontograma 
                                    :disable="disable" 
                                    :dientesSeleccionados="dientesSeleccionados" 
                                    :multiplesDientesSeleccionados="multiplesDientesSeleccionados" 
                                    :multiplesODS="multiplesODS"
                                    @dienteSeleccionado="dienteSeleccionado" 
                                   
                                /> -->
                                <nuevoOdontograma 
                                    :disable="disable" 
                                    :dientesSeleccionados="dientesSeleccionados" 
                                    :multiplesDientesSeleccionados="multiplesDientesSeleccionados" 
                                    :multiplesODS="multiplesODS"
                                    @dienteSeleccionado="dienteSeleccionado" 
                                    @multiplesODSeleccionado="multiplesODSeleccionado"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col style="margin-left: -7%; height: 77vh;">
                        <div>
                            <loading :active.sync="load" :can-cancel="false" :is-full-page="true"></loading>
                            <p class="text-left subTituloHC" style="margin-left: 3%;">Padecimientos detectados</p>
                            <div class="text-right w-50 d-flex justify-content-between">
                                <em class="boton_ordenar_categoria" v-b-tooltip.hover.v-light.topright="'Ordenar por categoría'" @click="ordenarCategoria()"></em>
                                <em class="boton_mult_tx" v-b-tooltip.hover.v-light.topright="'Agregar múltiples tratamientos'" @click="cambiarMultiplesTrts()"></em>
                                
                                <div class="d-flex" v-b-tooltip.hover.v-light.topright="'Crear segunda opción'" >
                                    <div id="popover-opciones"  class="d-flex align-items-center">
                                        <em class="boton_segunda_op"></em>
                                        <em class="arrow_down_svg" style="width: .6em;" :style="segundaOpcionAbierto ? 'transform: rotate(180deg)' : 'transform: rotate(0);' "></em>
                                    </div>
                                    <b-popover target="popover-opciones" triggers="hover blur" @show="onPopoverShow" @hidden="onPopoverHide">
                                        <b-button variant="outline-light" style="padding: 0px;" class="opcionesPopover"
                                                @click.prevent="segundaOpcion(1)"
                                        >
                                        Crear segunda opción a partir de tratamientos sugeridos
                                        </b-button>
                                        <b-button variant="outline-light" style="padding: 0px;" class="opcionesPopover"
                                                @click.prevent="segundaOpcion(2)"
                                        >
                                        Crear segunda opción a partir de la primera(duplicar)
                                        </b-button>
                                    </b-popover>
                                </div>

                                <em class="boton_mult_od" v-b-tooltip.hover.v-light.topright="'Agregar múltiples OD´S'" @click="agregarODS()"></em>
                                <em class="boton_ordenar_od" v-b-tooltip.hover.v-light.topright="'Ordenar ODs'" @click="ordenarODS()"></em>
                                <em class="boton_seleccionar_todo" v-b-tooltip.hover.v-light.topright="'Seleccionar todo'" @click="seleccionarTodo()"></em>
                                <div class="d-flex" v-b-tooltip.hover.v-light.topright="'Eliminar'" >
                                    <div id="popover-eliminar"  class="d-flex align-items-center">
                                        <em class="boton_eliminar"></em>
                                        <em class="arrow_down_svg" style="width: .6em;" :style="eliminarAbierto ? 'transform: rotate(180deg)' : 'transform: rotate(0);' "></em>
                                    </div>
                                    <b-popover target="popover-eliminar" triggers="hover blur" @show="onPopoverEliminarShow" @hidden="onPopoverEliminarHide">
                                        <template #button-content>
                                            <font-awesome-icon style="color: #0069aa" :icon="['fas', 'trash-alt']"/>
                                        </template>
                                        <b-form-group v-slot="{ ariaDescribedby }" class="ml-2 mt-2">
                                            <b-form-radio-group
                                                v-model="selected"
                                                :aria-describedby="ariaDescribedby"
                                                name="eliminar"
                                                stacked
                                            >
                                                <b-form-radio @change="validacionEliminar()" value="ods">OD'S</b-form-radio>
                                                <b-form-radio @change="validacionEliminar()" value="tratamientos">Tratamientos</b-form-radio>
                                                <b-form-radio @change="validacionEliminar()" class="ml-4" value="1">Opción 1</b-form-radio>
                                                <b-form-radio v-if="segundaOpcionCreada" @change="validacionEliminar()" class="ml-4" value="2">Opción 2</b-form-radio>
                                                <b-form-radio v-if="segundaOpcionCreada" value="segundaOpcion">PTI opción 2</b-form-radio>
                                        </b-form-radio-group>
                                        </b-form-group>
                                        <b-button variant="outline-primary" style="margin-left: 30%;" size="sm" @click="eliminarVarios()">Eliminar</b-button>
                                    </b-popover>
                                </div>

                                <em v-if="!activo" class="boton_mostrar_todo" v-b-tooltip.hover.v-light.topright="'Desplegar todo'" @click="desplegar()"></em>
                                <em v-else class="boton_ocultar_todo" v-b-tooltip.hover.v-light.topright="'Contraer todo'" @click="ocultar()"></em>
                            </div>
                        </div>

                            <div v-if="multiplesODS == false" :key="multiplesODS">
                                <div v-if="formulario.dientes.length === 0 && multiplesODS == false" class="mt-3 d-flex justify-content-center align-items-center" style=" min-height: 50vh;">
                                    <p style="font-size: .9em;">Sin órganos dentales seleccionados</p>
                                </div>
                                <div class="mt-4 pr-2 scrollable-container-hdx no-horizontal-scroll" style="min-height: 50vh;">
                                    <div class="mt-3 row" v-for="(diente,i) in formulario.dientes" :key="diente.diente.diente">
                                        <div class="col-1 text-left">
                                            <em v-if=" diente.padecimiento != null ? diente.padecimiento.idClasificacionClinica == 1 : false"
                                                class="fa fa-star mt-1" style="font-size: x-large; color: #FFC300;" 
                                                v-b-tooltip.hover.v-light.topright="'Este registro es prioridad clínica'"></em>
                                           
                                        </div>
                                        <div class="col" style="margin-left: -5%;" v-if="catTratamientos.length != 0">
                                            <HDPadecimientos
                                                :contraerCard="contraerCard"
                                                :catTratamientos="catTratamientos"
                                                :catalogokits="listaKits"
                                                :statePadecimiento="selectClassArray('dientes',i,'padecimiento')"
                                                :stateValidate="validateStateArray('dientes',i,'padecimiento')"
                                                :diente="diente"
                                                :index="i"
                                                :disable="disable"
                                                :id-tag-motivo-cita="formulario.idTagMotivoCita"
                                                :id-denticion="id_denticion"
                                                :id-clinica="formulario.idClinica"
                                                :idEmpleado="formulario.idEmpleado"
                                                :idPaciente="idPaciente"
                                                :segundaOpcionCreada="segundaOpcionCreada"
                                                :segundaOpcionSeleccionada="segundaOpcionSeleccionada"
                                                :multiTrt="multiTrt"
                                                :modificar="modificar"
                                                :quitarSegundaOpcion="quitarSegundaOpcion"
                                                :ordenarOds="ordenarOds"
                                                :obtenerSugerencias="obtenerSugerencias"
                                                @eliminarDiente="eliminarDiente"
                                                @cambiarVisibilidad="cambiarVisibilidad"
                                                @actualizarPadsAddNoReq="actualizarPadsAddNoReq"
                                                @cambioPadecimiento="cambioPadecimiento"
                                                :padOrtodoncia="padOrtodoncia"
                                                @padOrtodonciaModificado="padOrtodonciaModificado"
                                                @clasificacionesClinicas="clasificacionesClinicas"
                                                :padAdDiagnocat="padAdDiagnocat"
                                                :idSesion="idSesionSeleccionada"
                                                :accionesDiagnocat="accionesDiagnocat"
                                            ></HDPadecimientos>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <MultiplesODS
                                    :diente="formulario.dientes"
                                    :multiplesDientes="multiplesDientes"
                                    :disable="disable"
                                    :id-tag-motivo-cita="formulario.idTagMotivoCita"
                                    :id-denticion="id_denticion"
                                    :id-clinica="formulario.idClinica"
                                    @cancelarMultiple="cancelarMultiple"
                                    @eliminarDienteMultiple="eliminarDienteMultiple"
                                    @multiplesODSeleccionados="multiplesODSeleccionados"
                                ></MultiplesODS>
                            </div>
                    </b-col>
                </b-row>
                <div align="center">
                    <b-button variant="primary" pill @click="validacionOrtodoncia()">
                        guardar
                    </b-button>
                </div>
            </div>
            <div v-else style="height: 46em;">
                <MultiplesTratamientos
                :catTratamientos="catTratamientos"
                :formularioPadecimientos="formularioPadecimientos"
                :multiplesTrts="multiplesTrts"
                @cancelar="cancelar"
                @guardarMultiplesTrts="guardarMultiplesTrts"
                ></MultiplesTratamientos>
            </div>
        </div>
      <validacionHerramientasModal ref="validacionHerramienta"
                                   :idPaciente="idPaciente"
                                   :ptiSinHerramientas="ptiSinHerramientas"
                                   @borrador="borrador = $event"
                                   @continuar="continuar = $event"
                                   @numeroHerramientas ="numeroHerramientas = $event"
                                   @guardarNormal="guardarNormal"
                                   @guardarBorrador="guardarBorrador"
                                   :activoEnDiagnocat="activoEnDiagnocat"
      ></validacionHerramientasModal>

      <b-modal size="lg" v-model="modalOrtodoncia" hide-footer hide-header>
        <div class="m-3" style="text-align: center; color: #0C789E; font-weight: bold; font-size: x-large"><p>¡Hemos agregado un Tx de ortodoncia al PTI!</p></div>
        <b-row>
          <b-col cols="8" class="ml-2">
            <b-row>
              <b-col class="text-left">
                <p>¿Sabías que 8 de cada 10 pacientes tiene al menos una malposición o maloclusión dental? Es muy probable que tu paciente sea candidato a Ortodoncia, por lo mismo hemos agregado automáticamente un tratamiento de ortodoncia.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-left">
                <p>
                  Es buen momento para platicar con el sobre los beneficios de un tratamiento de Ortodoncia.
                </p>
              </b-col>
            </b-row>
            <br>
            <!--select de kits-->
            <b-row class="d-flex" v-if="!ortodonciaEliminada">
              <b-col cols="10" class="pr-1" v-if="listaKits.length !== 0"><SelectKits :tratamiento="trtOrtodoncia" :catalogokits="listaKits"></SelectKits></b-col>
              <b-col cols="2" class="pr-1 pl-1 pt-2">
                <b-button v-b-toggle="'kitOrtodoncia'"
                          variant="outline-info" size="sm" class="mr-1 mt-1 marginbotones tamanio-botones" @click="mostrarOcultarTrtKits()">
                  <b-icon icon="chevron-down" font-scale="1.1" :rotate="trtOrtodoncia.isOpen ? 180 : 0"></b-icon>
                </b-button>
                <b-button variant="outline-danger" pill class="mr-1 paddingbotones marginbotones tamanio-botones" v-b-popover.hover.top="'Eliminar Kit'" v-on:click="eliminarKit()">
                  <em class="eliminar_rojo_svg tamanio-iconos"></em>
                </b-button>
              </b-col>
            </b-row>
            <b-collapse :id="100+'kitOrtodoncia'+100" v-model="trtOrtodoncia.isOpen" accordion="my-KitTrt-accordion" role="my-KitTrt123panel" ref="my-kitTrt-collap">
              <b-row class="d-flex">
                <b-col class="p-0">
                  <b-row class="ml-0 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in trtOrtodoncia.listaTratamientos" :key="indexTratamiento">
                    <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                    <b-col align="left" class="p-0" cols="8"><span>{{ trt.nombreTratamiento }}</span></b-col>
                    <b-col cols="2" class="text-left ml-0 p-0"><span>{{ trt.cantidad }}</span></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row class="d-flex" v-if="!ortodonciaEliminada">
              <b-col cols="10" class="pr-1">
                <v-select v-if="tieneBocaCompleta" placeholder="Selecciona la categoría" v-model="padOrtodonciaPorOd.idClasificacionClinica"
                          :options="opcionesClasificacionClinica"
                          label="clasificacionClinica" :reduce="(variable) => variable.idClasificacionClinica"/>
                <v-select v-else placeholder="Selecciona la categoría" v-model="padOrtodoncia.idClasificacionClinica"
                          :options="opcionesClasificacionClinica"
                          label="clasificacionClinica" :reduce="(variable) => variable.idClasificacionClinica"/>
              </b-col>
            </b-row>
            <b-row class="d-flex" v-if="!agregarTratamientoOrtodoncia && !ortodonciaEliminada">
              <b-col class="text-center">
                <b-button style="width: 30%;"
                          variant="link"
                          @click="agregarTratamientoOrtodoncia = true">
                  <font-awesome-icon icon="plus-circle"/>
                </b-button>
              </b-col>
            </b-row>
            <b-row class="d-flex" v-if="!agregarTratamientoOrtodoncia && !ortodonciaEliminada">
              <b-col class="text-center">
                <p>Agrega tratamientos adicionales relacionados a ortodoncia</p>
              </b-col>
            </b-row>
            <b-row class="d-flex" v-if="ortodonciaEliminada">
              <b-col cols="3"></b-col>
              <b-col class="text-center" style="color: grey">
                <p style="font-size: x-small">Haz removido el tratamiento de ortodoncia que agregamos. Si deseas volver a agregar haz clic en "Regresar"</p>
              </b-col>
              <b-col cols="3"></b-col>
            </b-row>
          </b-col>
          <b-col class="mr-2">
            <!--imagen-->
            <b-card class="bCardGlobalXXL p-2" no-body>
              <b-img
                  :src="require('@/assets/kitOrtodoncia.jpeg')"
                  alt="Kit"
                  class="logoDentalia"
              ></b-img>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="agregarTratamientoOrtodoncia && !ortodonciaEliminada">
          <b-row class="mt-3 text-left mb-3">
            <b-col>
              <p class="headers">Tratamientos adicionales</p>
            </b-col>
            <b-col cols="2">
              <p class="headers">Cantidad</p>
            </b-col>
            <b-col cols="1" align="left" class="pl-0">
              <div class="d-flex" style="margin-top: -10px;">
                <div>
                  <b-button style="width: 30%;"
                            v-if="!disable"
                            v-b-tooltip.hover title="Agregar Tratamiento"
                            variant="link"
                            @click="agregarTratamiento()">
                    <font-awesome-icon icon="plus-circle"/>
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr style="margin-top: -2%;">

          <div v-if="tratamientosOrtodoncia.length > 0">
            <div v-for="(item, i) in tratamientosOrtodoncia" :key="'tratamiento' + i">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col>
                  <div class="d-flex align-items-center">
                    <SelectTratamientos
                        style="width: 100%;"
                        :indexPadecimiento="100"
                        :indexOpcion="100"
                        :catalogoTratamientos="catTratamientos"
                        :catalogokits="listaKits"
                        :idSeleccionado="item.idTratamiento"
                        :tratamiento="item"
                        :tratamientos="tratamientosOrtodoncia"
                        :i="i"
                    ></SelectTratamientos>
                  </div>
                </b-col>
                <b-col cols="2" align="center">
                  <b-input min="1" type="number" v-model="item.cantidad"></b-input>
                </b-col>
                <b-col cols="1" class="pr-1 pl-1">
                  <b-button size="sm" v-b-tooltip.hover title="Eliminar Tratamiento"
                            style="color: red !important;" variant="link"
                            @click="eliminarTratamiento(item)">
                    <font-awesome-icon icon="times-circle"/>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 15vh;">
            <p>Sin tratamientos agregados</p>
          </div>
        </div>
        <br>
        <div class="m-4" v-if="!ortodonciaEliminada" align="center">
          <b-button variant="primary" pill @click="guardarOrtodoncia()">Continuar con ortodoncia</b-button>
        </div>
        <b-row class="m-4" v-else>
          <b-col align="center"><b-button variant="primary" pill @click="ortodonciaEliminada = false">Regresar</b-button></b-col>
          <b-col align="left"><b-button variant="secondary" pill @click="validacionHerramientasModal(); modalOrtodoncia = false;">Continuar sin ortodoncia</b-button></b-col>
        </b-row>
      </b-modal>
    </div>
</template>
    
<script>
    import nuevoOdontograma from '../../version5/diagnostico/NuevoOdontograma.vue';
    /* import odontograma from '../../version5/diagnostico/Odontograma.vue'; */
    import HDPadecimientos from "../diagnostico/HDPadecimientos.vue"
    import MultiplesODS from "../../views/odontograma/detalleDiagnostico/MultiplesODS";
    import {required} from "vuelidate/lib/validators";
    import herramientasModal from "@/version5/herramientas/componentes/HerramientasModal";
    import validacionHerramientasModal from "@/version5/herramientas/componentes/validacionHerramientasModal";
    import observacionesCita from "@/version5/cita/componentes/ObservacionesCita";
    import MultiplesTratamientos from './MultiplesTratamientos.vue';
    import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
    import ModificarTagMotivoCita from "@/version5/diagnostico/ModificarTagMotivoCita";
    import SelectKits from "@/version5/diagnostico/SelectKits.vue";
    import SelectTratamientos from "./SelectTratamientos.vue";
    import DiagnocatModal from '../diagnocat/DiagnocatModal.vue';
    import {DientesEnum} from '@/constantes/Dientes.js';
    import {AccionesDiagnocatEnum} from "@/constantes/AccionesDiagnocat";

    export default {
        name: "HojaDiagnostico",
        components: {
          SelectTratamientos,
          ModificarTagMotivoCita,
            observacionesCita,
            herramientasModal,
            nuevoOdontograma,
            HDPadecimientos,
            MultiplesODS,
            validacionHerramientasModal,
            MultiplesTratamientos,
            SelectKits,
            DiagnocatModal
        },
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
                ptiPrsuntivoServicio: new PtiPresuntivoService(),
                eliminarAbierto: false,
                segundaOpcionAbierto: false,
                catTratamientos: [],
                listaKits: [],
                load: false,
                loading: false,
                formulario: {
                    fechaSolicitud: new Date(),
                    idClinica: null,
                    idEmpleado: null,
                    idFlujo: null,
                    idTagMotivoCita: null,
                    diagnosticador: null,
                    dientes: [],
                },
                idSolicitudEtapa: null,

                activo: false,
                todo: false,
                disable: false,
                id_denticion: null,
                ordenarOds: false,

                dientesSeleccionados: [],
                multiplesDientesSeleccionados: [],
                multiplesODS: false,
                multiplesDientes: [],
                
                selected: null,
                segundaOpcionCreada: false,
                segundaOpcionSeleccionada: 0,
                borrador: false,

                multiplesTrts: false,
                multiTrt: false,
                modificar: false,
                quitarSegundaOpcion: false,
                grupos: [],
                formularioPadecimientos: [],
                continuar: false,
                numeroHerramientas: null,
                
                nivelPTI: null,
                
                borradorExistente: false,
                idEtapa: null,
                tagMotivoSeleccionado: null,

                obtenerSugerencias: false,

                //variables temporales
                tienePti: true,
                idCitaPaciente: null,
                tagmotivocitaDatosArrayOriginal: [],
                cambioTag: null,
                tag: null,
                modalOrtodoncia: false,
                trtOrtodoncia: {
                  nombreKit: null,
                  nombreTratamiento: null,
                  idKit: null,
                  listaTratamientos: [],
                  idTratamiento: null,
                  opcion: 0,
                  precio: 0,
                },
                padOrtodoncia: {
                  nombrePadecimiento: null,
                  idPadecimiento: null,
                  idClasificacionClinica: null,
                },
                agregarTratamientoOrtodoncia: false,
                tratamientosOrtodoncia: [],
                ortodonciaEliminada: false,
                tieneBocaCompleta: false,
                padOrtodonciaPorOd: {
                  nombrePadecimiento: null,
                  idPadecimiento: null,
                  idClasificacionClinica: null,
                },
                opcionesClasificacionClinica: [],
                activoEnDiagnocat: false,
                dientesEnum: DientesEnum,
                padAdDiagnocat: [],
                accionesDiagnocat: AccionesDiagnocatEnum,
            }
        },
        validations: {
            formulario: {
                fechaSolicitud: {},
                idClinica: {},
                idEmpleado: {},
                idFlujo: {},
                idTagMotivoCita: {required},
                dientes: {
                    required,
                    $each: {
                        padecimiento: {required}
                    }
                },
            }
        },
        props: {
            idPaciente: Number,
            contraerCard: Boolean,
            idSesionSeleccionada: Number,
            idCita: Number,
            existeRechazoDesentralizado: {
                type: Boolean,
                default: false
            },
            idPtiRechazo: Number,
            etapaRechazo: Number,
            solicitudRechazo: Number,
            idPti: Number,

            idDenticion: Number,
            ptiSinHerramientas: Boolean,
        },
        watch: {
            tagMotivoSeleccionado(newVal) {
                //this.$emit('TagMotivoSeleccionado', newVal);
                this.cambioTag = newVal;
                this.formulario.idTagMotivoCita = newVal.idTagMotivoCita
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.id_denticion = 2;
            this.formulario.idEmpleado = this.$localStorageService.getIdEmpleado();
            this.formulario.empleado = this.$localStorageService.getNombreCompletoUsuario();
            this.formulario.idClinica = this.$localStorageService.getIdClinica();
            this.formulario.idSesion = this.idSesionSeleccionada;
            this.idEtapa = this.$route.params.idEtapa
            this.idSolicitudEtapa = Number(this.$route.params.sesion != null ? this.$route.params.sesion : this.$route.params.idSolicitudEtapa);
            this.obtenerTratamientos()
            this.tagSeleccionadoEnLaCita()
            this.obtenerClinicaDiagnocat()

            //metodos mientras no esta el menu lateral
            if(this.idCita == undefined || this.idCita == null){
                this.obtenerCita();
            }else{
                this.idCitaPaciente = this.idCita;
            }
            if(this.idEtapa != 101 && this.idEtapa != 95){
                this.existePti();
            }

            if(this.existeRechazoDesentralizado){
                this.obtenerInformacionHDX()
                this.obtenerSugerencias = true;
            }else{
                this.obtenerBorrador()
            }
        },
        methods: {
          //obtenemos el diente de la agrupacion
          obtenerAgrupacionPorDiente(idDiente, idTipoAgrupacion){
            let agrupacion = null;

            //validamos el tipo de agrupacion que genera el padecimiento y el diente agregado para saber que a agrupacion se crea
            if (idTipoAgrupacion === this.dientesEnum.BOCACOMPLETA.idTipoAgrupacion && this.dientesEnum.DIENTESBOCACOMPLETA.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.BOCACOMPLETA;
            } else if (idTipoAgrupacion === this.dientesEnum.ARCADA.idTipoAgrupacion && this.dientesEnum.DIENTESMAXILARSUPERIOR.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.MAXILARSUPERIOR;
            } else if (idTipoAgrupacion === this.dientesEnum.ARCADA.idTipoAgrupacion && this.dientesEnum.DIENTESMAXILARINFERIOR.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.MAXILARINFERIOR;
            } else if (idTipoAgrupacion === this.dientesEnum.CUADRANTE.idTipoAgrupacion && this.dientesEnum.DIENTESCUADRANTE1.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.CUADRANTE1;
            } else if (idTipoAgrupacion === this.dientesEnum.CUADRANTE.idTipoAgrupacion && this.dientesEnum.DIENTESCUADRANTE2.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.CUADRANTE2;
            } else if (idTipoAgrupacion === this.dientesEnum.CUADRANTE.idTipoAgrupacion && this.dientesEnum.DIENTESCUADRANTE3.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.CUADRANTE3;
            } else if (idTipoAgrupacion === this.dientesEnum.CUADRANTE.idTipoAgrupacion && this.dientesEnum.DIENTESCUADRANTE4.idsDientes.some(maxSup => maxSup === idDiente)){
              agrupacion = this.dientesEnum.CUADRANTE4;
            }

            return agrupacion
        },

      recibirOdontograma(payload) {
        //inicializamos variable
        let agrupacionesAgregar = {
          padecimientosQuitar: [],
          padecimientosNuevos: [],
          dientesQuitar: [],
          dientesNuevos: [],
        };

        //iteramos padecimientos para encontrar los que forman alguna agrupacion
        payload.padecimientos.forEach(pad => {
          let padecimientoGeneraAgrupacion = this.padecimientosConAgrupaciones.find(pca => pca.idPadecimiento === pad.idPadecimiento);
          if (padecimientoGeneraAgrupacion != null){//validamos que se encuentre una agrupacion al padecimiento

            agrupacionesAgregar.padecimientosQuitar.push(pad);
            agrupacionesAgregar.dientesQuitar.push(pad.idDiente);

            //obtenemos el diente que se va a agregar
            const dienteAgregar = this.obtenerAgrupacionPorDiente(pad.idDiente, padecimientoGeneraAgrupacion.idTipoAgrupacion);

            //validar que el mismo diente con el mismo padecimiento no ha sido agregado
            if (!agrupacionesAgregar.padecimientosNuevos.some(padNuevo => padNuevo.idDiente === dienteAgregar.idDiente && padNuevo.idPadecimiento === pad.idPadecimiento)){
              //agregamos el padecimiento con la agrupacion que corresponde
              agrupacionesAgregar.padecimientosNuevos.push({
                descripcion: pad.descripcion,
                idClasificacionClinica: pad.idClasificacionClinica,
                idDiente: dienteAgregar.idDiente,
                idPadecimiento: pad.idPadecimiento
              });
            }

            //agregamos el diente con la agrupacion que corresponde
            agrupacionesAgregar.dientesNuevos.push({
              numDiente: dienteAgregar.diente,
              idDiente: dienteAgregar.idDiente
            });
          }
        })

        //quitamos los padecimientos que formaron agrupaciones
        agrupacionesAgregar.padecimientosQuitar.forEach(padQ=>{
          const padQuitar = payload.padecimientos.findIndex(pq => pq.idDiente === padQ.idDiente && pq.idPadecimiento === padQ.idPadecimiento);
          if (padQuitar !== -1) payload.padecimientos.splice(padQuitar,1);
        })

        //quitamos los dientes que formaron agrupaciones
        agrupacionesAgregar.dientesQuitar.forEach(dienteQ=>{
          const dienteQuitar = payload.dientes.findIndex(dq => dq.idDiente === dienteQ);
          if (dienteQuitar !== -1) payload.dientes.splice(dienteQuitar, 1);
        })

        //agregamos padecimientos nuevos por la grupacion formada
        agrupacionesAgregar.padecimientosNuevos.forEach(padNuevo=>{
          payload.padecimientos.push(padNuevo)
        })

        //agregamos dientes nuevos por la grupacion formada
        agrupacionesAgregar.dientesNuevos.forEach(dienteNuevo=>{
          payload.dientes.push(dienteNuevo)
        })


        //revisamos si ya existen dientes agregados
            if (this.dientesSeleccionados.length === 0) {
              this.dientesSeleccionados = payload.dientes;
            } else {
              payload.dientes.forEach(diente => {
                this.dientesSeleccionados.push(diente)
              })
            }




            const { dientes, padecimientos } = payload

            // Agrupar padecimientos por diente
            const padecimientosPorDiente = {}

            padecimientos.forEach(pad => {
              if (!padecimientosPorDiente[pad.idDiente]) {
                padecimientosPorDiente[pad.idDiente] = []
              }
              padecimientosPorDiente[pad.idDiente].push(pad)
            })

            //regresamos dientes que se quitaron en agrupacion, pero que tienen otro padecimiento para diente individual
            padecimientos.forEach(pad => {
              if (!dientes.some(diente => diente.idDiente === pad.idDiente)){
                dientes.unshift({
                  numDiente: this.obtenerDiente(pad.idDiente),
                  idDiente: pad.idDiente
                });
              }
            })


            this.padAdDiagnocat = [];
            Object.keys(padecimientosPorDiente).forEach(idDiente => {

              const dienteBase = dientes.find(d => d.idDiente === Number(idDiente))
              if (!dienteBase) return

              // evitar duplicar card del mismo diente
              const existeCard = this.formulario.dientes.some(
                  d => d.diente.idDiente === dienteBase.idDiente
              )

              // Si existe el diente se tiene que agregar como padecimiento adicional
              if (existeCard) {
                const idsPadecimientos = padecimientosPorDiente[idDiente].map(pad => pad.idPadecimiento);
                idsPadecimientos.forEach(idPad =>{

                  let padecimientoDiente = this.formulario.dientes.find(d => d.diente.idDiente === dienteBase.idDiente);
                  if (padecimientoDiente.padecimiento.idPadecimiento !== idPad){ //Padecimiento agregado desde diagnocat es diferente al padecimiento agregado manualmente
                    let padecimientosAdicionalesNoReq = []
                    if (padecimientoDiente.padecimientosAdicionalesNoReq === undefined || padecimientoDiente.padecimientosAdicionalesNoReq === null || padecimientoDiente.padecimientosAdicionalesNoReq.length === 0) { //validamos si ya tiene padecimientos adicionales
                      if (this.padAdDiagnocat.length > 0){//validamos si ya tenemos dientes para agregar de diagnocat
                        this.padAdDiagnocat.push({"pad": idPad, "idDiente": dienteBase.idDiente});
                      } else {
                        this.padAdDiagnocat = [{"pad": idPad, "idDiente": dienteBase.idDiente}];
                      }

                    } else if (!padecimientoDiente.padecimientosAdicionalesNoReq.some(pda => pda.pad === Number(idPad))) { //Se revisa que el padecimiento de diagnocat no este en la lista de padecimientos adicionales para agregarlo
                      padecimientosAdicionalesNoReq = padecimientoDiente.padecimientosAdicionalesNoReq;
                      padecimientosAdicionalesNoReq.push({"pad": idPad, "idDiente": dienteBase.idDiente});
                      this.padAdDiagnocat = padecimientosAdicionalesNoReq;

                    }

                  }

                })
                //termianos iteracion porque no se agrega tarjeta de diente, se agregaron padecimientos adicionales a una tarjeta ya existente
                return
              }


              const pads = padecimientosPorDiente[idDiente]

              // primer padecimiento → principal
              const padecimientoPrincipal = pads[0]

              // resto → adicionales
              const padecimientosAdicionales = pads.slice(1).map(p => ({
                pad: p.idPadecimiento
              }))

              this.formulario.dientes.unshift({
                diente: {
                  idDiente: dienteBase.idDiente,
                  diente: dienteBase.numDiente,
                },
                buscar: true,
                seleccionar: false,
                visible: false,
                padecimiento: {
                  idPadecimiento: padecimientoPrincipal.idPadecimiento,
                  descripcion: padecimientoPrincipal.descripcion,
                  idClasificacionClinica: padecimientoPrincipal.idClasificacionClinica,
                  modificado: false,
                  idEstudioDiagnocat: payload.idEstudio,
                  idAnalisisDiagnocat: payload.idAnalisis,
                },
                padecimientoDiagnocat: {
                  idEstudioDiagnocat: payload.idEstudio,
                  idAnalisisDiagnocat: payload.idAnalisis,
                },
                tratamientos: [],
                visiblePadecimiento: false,

                // 👇 pestaña "Padecimientos"
                padecimientosAdicionalesNoReq: padecimientosAdicionales
              })
            })

          },

          //obtenemos el diente que se quito para la agrupacion
          obtenerDiente(idDiente){
            const listaDientes = Object.entries(this.dientesEnum).map(([key, value]) => {
              return { property: key, data: value };
            });

            return listaDientes.filter(ld => ld.data.idDiente === idDiente)[0].data.diente;
          },

          //Valida los dientes que se quitan para crear la agrupacion del cuadrante 1
          quitarDienteCuadrante1(dienteMismoPad, payload){
            dienteMismoPad.forEach(dmp => {
              if (dmp.idDiente === this.dientesEnum.OD11.idDiente || dmp.idDiente === this.dientesEnum.OD12.idDiente
                  || dmp.idDiente === this.dientesEnum.OD13.idDiente || dmp.idDiente === this.dientesEnum.OD14.idDiente
                  || dmp.idDiente === this.dientesEnum.OD15.idDiente || dmp.idDiente === this.dientesEnum.OD16.idDiente
                  || dmp.idDiente === this.dientesEnum.OD17.idDiente || dmp.idDiente === this.dientesEnum.OD18.idDiente){
                payload.padecimientos.splice(payload.padecimientos.findIndex(pad => pad === dmp),1);
                payload.dientes.splice(payload.dientes.findIndex(diente => diente.idDiente === dmp.idDiente),1);
              }
            });
          },

          //Valida los dientes que se quitan para crear la agrupacion del cuadrante 2
          quitarDienteCuadrante2(dienteMismoPad, payload){
            dienteMismoPad.forEach(dmp => {
              if (dmp.idDiente === this.dientesEnum.OD21.idDiente || dmp.idDiente === this.dientesEnum.OD22.idDiente
                  || dmp.idDiente === this.dientesEnum.OD23.idDiente || dmp.idDiente === this.dientesEnum.OD24.idDiente
                  || dmp.idDiente === this.dientesEnum.OD25.idDiente || dmp.idDiente === this.dientesEnum.OD26.idDiente
                  || dmp.idDiente === this.dientesEnum.OD27.idDiente || dmp.idDiente === this.dientesEnum.OD28.idDiente){
                payload.padecimientos.splice(payload.padecimientos.findIndex(pad => pad === dmp),1);
                payload.dientes.splice(payload.dientes.findIndex(diente => diente.idDiente === dmp.idDiente),1);
              }
            });
          },

          //Valida los dientes que se quitan para crear la agrupacion del cuadrante 3
          quitarDienteCuadrante3(dienteMismoPad, payload){
            dienteMismoPad.forEach(dmp => {
              if (dmp.idDiente === this.dientesEnum.OD31.idDiente || dmp.idDiente === this.dientesEnum.OD32.idDiente
                  || dmp.idDiente === this.dientesEnum.OD33.idDiente || dmp.idDiente === this.dientesEnum.OD34.idDiente
                  || dmp.idDiente === this.dientesEnum.OD35.idDiente || dmp.idDiente === this.dientesEnum.OD36.idDiente
                  || dmp.idDiente === this.dientesEnum.OD37.idDiente || dmp.idDiente === this.dientesEnum.OD38.idDiente){
                payload.padecimientos.splice(payload.padecimientos.findIndex(pad => pad === dmp),1);
                payload.dientes.splice(payload.dientes.findIndex(diente => diente.idDiente === dmp.idDiente),1);
              }
            });
          },

          //Valida los dientes que se quitan para crear la agrupacion del cuadrante 4
          quitarDienteCuadrante4(dienteMismoPad, payload){
            dienteMismoPad.forEach(dmp => {
              if (dmp.idDiente === this.dientesEnum.OD41.idDiente || dmp.idDiente === this.dientesEnum.OD42.idDiente
                  || dmp.idDiente === this.dientesEnum.OD43.idDiente || dmp.idDiente === this.dientesEnum.OD44.idDiente
                  || dmp.idDiente === this.dientesEnum.OD45.idDiente || dmp.idDiente === this.dientesEnum.OD46.idDiente
                  || dmp.idDiente === this.dientesEnum.OD47.idDiente || dmp.idDiente === this.dientesEnum.OD48.idDiente){
                payload.padecimientos.splice(payload.padecimientos.findIndex(pad => pad === dmp),1);
                payload.dientes.splice(payload.dientes.findIndex(diente => diente.idDiente === dmp.idDiente),1);
              }
            });
          },

            onPopoverShow() {
            this.segundaOpcionAbierto = true;
            },
            onPopoverHide() {
            this.segundaOpcionAbierto = false;
            },

            onPopoverEliminarShow() {
            this.eliminarAbierto = true;
            },
            onPopoverEliminarHide() {
            this.eliminarAbierto = false;
            },

            obtenerTratamientos() {
                this.loading = true;
                const params= {
                    idClinica: this.$localStorageService.getIdClinica()
                }
                this.ptiPrsuntivoServicio.obtenerTramientosKitsPorClinica(params).then(
                    response => {
                        this.catTratamientos = response.listaTratamientos;
                        this.listaKits = response.listaKits;
                        this.loading = false;
                    }
                ).finally(()=>{
                  let kitOrtodoncia = JSON.parse(JSON.stringify(this.listaKits))
                  let ortodoncia = kitOrtodoncia.filter(ko=>ko.idKit === 16)
                  this.trtOrtodoncia = ortodoncia[0]
                  this.trtOrtodoncia.nombreTratamiento = this.trtOrtodoncia.nombreKit;
                });
            },

            segundaOpcion(opcion){
                this.multiTrt = false;
                this.modificar = true;
                this.ordenarOds = false;
                this.segundaOpcionCreada = true;
                this.segundaOpcionSeleccionada = opcion;
            },

            agregarODS(){
                this.multiplesODS = true;
                this.multiplesDientes = [];
                this.multiplesDientesSeleccionados = [];
            },

            ordenarODS(){
                this.ordenarOds = true;
                let dientesOrdenados = [];
                // dar orden a boca completa
                this.formulario.dientes.forEach(d => {
                    d.cambio = false;
                    if(d.diente.idDiente == 59){
                        if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 179 
                        && d.padecimiento.idPadecimiento != 74 && d.padecimiento.idPadecimiento != 73)){
                            d.diente.orden = 33
                        } else if(d.padecimiento.idPadecimiento == 73){
                            d.diente.orden = 34
                        } else if(d.padecimiento.idPadecimiento == 74){
                            d.diente.orden = 35
                        } else if(d.padecimiento.idPadecimiento == 179){
                            d.diente.orden = 36
                        }
                    }
                    // dar orden a superior
                    if(d.diente.idDiente == 57){
                        if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 165 
                        && d.padecimiento.idPadecimiento != 162 && d.padecimiento.idPadecimiento != 49 
                        && d.padecimiento.idPadecimiento != 10)){
                            d.diente.orden = 37
                        } else if(d.padecimiento.idPadecimiento == 10){
                            d.diente.orden = 38
                        } else if(d.padecimiento.idPadecimiento == 49){
                            d.diente.orden = 39
                        } else if(d.padecimiento.idPadecimiento == 162){
                            d.diente.orden = 40
                        } else if(d.padecimiento.idPadecimiento == 165){
                            d.diente.orden = 41
                        }
                    }
                    // dar orden a inferior
                    if(d.diente.idDiente == 58){
                        if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 49 
                        && d.padecimiento.idPadecimiento != 162 && d.padecimiento.idPadecimiento != 165)){
                            d.diente.orden = 42
                        } else if(d.padecimiento.idPadecimiento == 49){
                            d.diente.orden = 43
                        } else if(d.padecimiento.idPadecimiento == 162){
                            d.diente.orden = 44
                        } else if(d.padecimiento.idPadecimiento == 165){
                            d.diente.orden = 45
                        }
                    }
                });
                dientesOrdenados = this.formulario.dientes
                let dientes = dientesOrdenados.map(dior => dior.diente.orden);
                var length = dientes.length; 
                for (var i = 0; i < length; i++) {
                    for (var j = 0; j < (length - i - 1); j++) {
                        if(dientes[j] > dientes[j+1]) {
                            var tmp = dientes[j]; 
                            dientes[j] = dientes[j+1]; 
                            dientes[j+1] = tmp; 
                        }
                    }
                }
                this.load = true;
                this.formulario.dientes = [];
                setTimeout(() => {
                    for (let i = 0; i < dientes.length; i++) {
                        this.formulario.dientes.push(dientesOrdenados[dientesOrdenados.findIndex(d => d.diente.orden == dientes[i])]);
                    }
                    this.load = false;
                }, 500);
                this.load = false;
            },

            seleccionarTodo() {
                this.todo = !this.todo
                this.formulario.dientes.forEach(d => d.seleccionar = this.todo)
            },

            validacionEliminar(){
                const index = [];
                this.formulario.dientes.forEach((d, i) => {
                    if (d.seleccionar) {
                        index.push(i);
                    }
                })

                if (index.length === 0) {
                    this.$swal.fire({
                        html: '<div style="text-align:left;font-weight: bold; color: #0c26a7"><i class="fa fa-times-circle-o"></i> Eliminar órganos dentales</div> <br>' +
                            '<div style="text-align:left; font-size: small">No se encontraron elementos seleccionados para eliminar, por favor seleccione elementos para eliminarlos</div>',
                        confirmButtonText: 'Cerrar',
                        customClass: {
                            confirmButton: "text-small",
                        },
                        allowOutsideClick: false
                    }).then((aceptar) =>{
                        if(aceptar.isConfirmed){
                            this.selected = null;
                            return;
                        }
                    });
                }
            },

            eliminarVarios() {
                const index = [];
                this.formulario.dientes.forEach((d, i) => {
                    if (d.seleccionar) {
                        index.push(i);
                    }
                })

                if(this.selected == 'ods'){
                    this.$swal
                    .fire({
                        title: "<span style='font-size: small'>¿Estás seguro de que quieres eliminar todos los padecimientos?</span>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        customClass: {
                            confirmButton: "btn-primary text-small",
                            cancelButton: "btn-secondary text-small",
                        },
                    })
                    .then((result) => {

                        if (result.isConfirmed) {
                            index.reverse().forEach(i => this.eliminarDiente(this.formulario.dientes[i]));
                            this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                            this.selected = null;
                        }
                    });
                }else if(this.selected == 'tratamientos'){
                    this.$swal
                    .fire({
                        title: "<span style='font-size: small'>¿Estás seguro de que quieres eliminar todos los Tratamientos?</span>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        customClass: {
                            confirmButton: "btn-primary text-small",
                            cancelButton: "btn-secondary text-small",
                        },
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            index.reverse().forEach(i => {
                                this.formulario.dientes[i].tratamientos = [];
                                this.formulario.dientes[i].tratamientos.push([]);
                                if(this.segundaOpcionCreada){
                                    this.formulario.dientes[i].tratamientos.push([]);
                                }
                            })
                            this.selected = null;
                        }
                    });
                }else if(this.selected == '1'){
                    this.$swal
                    .fire({
                        title: "<span style='font-size: small'>¿Estás seguro de que quieres eliminar todos los Tratamientos del PTI I?</span>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        customClass: {
                            confirmButton: "btn-primary text-small",
                            cancelButton: "btn-secondary text-small",
                        },
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            index.reverse().forEach(i => {
                                this.formulario.dientes[i].tratamientos.splice(0, 1, []);
                            })
                            this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                            this.selected = null;
                        }
                    });
                }else if(this.selected == '2'){
                    this.$swal
                    .fire({
                        title: "<span style='font-size: small'>¿Estás seguro de que quieres eliminar todos los Tratamientos del PTI II?</span>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        customClass: {
                            confirmButton: "btn-primary text-small",
                            cancelButton: "btn-secondary text-small",
                        },
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            index.reverse().forEach(i => {
                                this.formulario.dientes[i].tratamientos.splice(1, 1, []);
                            })
                            this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                            this.selected = null;
                        }
                    });
                }else if(this.selected == 'segundaOpcion'){
                    this.$swal.fire({
                        title: "<span style='font-size: medium'>¿Estás seguro de que quieres eliminar la segunda opción?</span>",
                        focusConfirm: false,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        customClass: {
                            confirmButton: "btn-primary text-small",
                            cancelButton: "btn-secondary text-small",
                        },
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            this.formulario.dientes.forEach(element => {
                                element.cambio = false;
                            });
                            this.quitarSegundaOpcion = true;
                            this.multiTrt = false;
                            this.segundaOpcionCreada = false;
                            this.segundaOpcionSeleccionada = 0;
                            this.selected = null;
                        }
                    });
                }
            },
            desplegar() {
                this.formulario.dientes.forEach(diente => {
                    if (diente.padecimiento != null) {
                        diente.visible = true;
                    }
                })
                this.activo = true
                
            },
            ocultar() {
                this.formulario.dientes.forEach(diente => {
                    if (diente.padecimiento != null) {
                        diente.visible = false;
                    }
                })
                this.activo = false
            },

            dienteSeleccionado(data) {
                this.diente = data.diente;

                this.dientesSeleccionados = data.dientes;
                if (data.diente.idDiente != 137) {
                    const i = this.formulario.dientes.map(d => d.diente.idDiente).indexOf(this.diente.idDiente)
                    if (i > -1) {
                        this.$swal.fire({
                            icon: "error",
                            title: "<span style='font-size: medium'>upps, no se puede agregar otro \n padecimiento a este diente</span>",
                            text: "pero no te preocupes, intenta con otro diente",
                            customClass: {
                                confirmButton: "text-small",
                                content: "text-small",
                            }
                        });
                        return;
                    }
                }
                this.formulario.dientes.unshift({
                    diente: this.diente,
                    buscar: true,
                    seleccionar: false,
                    visible: false,
                    padecimiento: null,
                    tratamientos: [],
                    visiblePadecimiento: false
                });
            },

            multiplesODSeleccionado(data) {
                this.diente = data.diente;
                if (data.diente.idDiente != 137) {
                    const i = this.multiplesDientes.map(d => d.idDiente).indexOf(this.diente.idDiente)
                    if (i > -1) {
                        this.$swal.fire({
                            icon: "error",
                            title: "<span style='font-size: medium'>upps, no se puede agregar otro \n padecimiento a este diente</span>",
                            text: "pero no te preocupes, intenta con otro diente",
                            customClass: {
                                confirmButton: "text-small",
                                content: "text-small",
                            }
                        });
                        return;
                    }
                }
                this.multiplesDientes.unshift(this.diente);
            },

            multiplesODSeleccionados(data) {
                this.multiplesODS = false;
                this.modificar = false;
                this.load = true;
                setTimeout(() => {
                    data.dientes.forEach(md => {
                        this.formulario.dientes.unshift({
                            diente: md,
                            buscar: true,
                            seleccionar: false,
                            visible: false,
                            padecimiento: JSON.parse(JSON.stringify(data.padecimiento)),
                            tratamientos: [],
                            visiblePadecimiento: false
                        });
                        this.dientesSeleccionados.unshift(md);
                    });
                    this.load = false;
                }, 1000);
            },

            cancelarMultiple(){
                this.modificar = false;
                this.multiplesODS = false;
                this.multiplesDientesSeleccionados = [];
            },

            eliminarDiente(item) {
                const index = this.formulario.dientes.indexOf(item);
              if (this.formulario.dientes[index].padecimientoDiagnocat !== undefined && this.formulario.dientes[index].padecimientoDiagnocat !== null && (this.formulario.dientes[index].padecimientoDiagnocat.idEstudioDiagnocat !== null && this.formulario.dientes[index].padecimientoDiagnocat.idAnalisisDiagnocat !== null)){
                  let accionDiagnocat = {
                    idPaciente: this.idPaciente,
                    idEstudio: this.formulario.dientes[index].padecimientoDiagnocat.idEstudioDiagnocat,
                    idAnalisis: this.formulario.dientes[index].padecimientoDiagnocat.idAnalisisDiagnocat,
                    idAccion: [this.accionesDiagnocat.ELIMINAR_DIENTE],
                    idSesion: this.idSesionSeleccionada,
                  }

                  this.$http.post( this.$api + "version5/bitacoraAccionesDiagnocat/guardarAccionesDiagnocat", accionDiagnocat);

                }
                this.formulario.dientes.splice(index, 1)
                this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
            },

            cambiarVisibilidad(){
                const hayVisibles = this.formulario.dientes.filter(diente=>diente.visible == true)
                this.activo = hayVisibles.length > 0 ? true : false;
            },

            eliminarDienteMultiple(item) {
                var dientes = this.multiplesDientesSeleccionados;
                const index = dientes.indexOf(item);
                dientes.splice(index, 1)
                this.multiplesDientesSeleccionados = dientes;
            },

            actualizarPadsAddNoReq(datosAct) {
                const dienteActualizar = this.formulario.dientes.find(d=>d.diente.idDiente === datosAct.idDiente);

                if (dienteActualizar != undefined && dienteActualizar != null) {
                    dienteActualizar.padecimientosAdicionalesNoReq = datosAct.pads;
                }
                this.$forceUpdate();

            },

            validateStateArray(name, index, name2) {
                const {$dirty, $error} = this.$v.formulario[name].$each[index][name2];
                return $dirty ? !$error : null;
            },

            selectClassArray(name, index, name2) {
                let state = this.validateStateArray(name, index, name2);
                if (state) {
                    return "border rounded-lg border-success";
                } else if (state === false && name2 == 0) {
                    return "border rounded-lg border-danger";
                } else {
                    return "";
                }
            },

            async validacionHerramientasModal() {
                await this.$refs.validacionHerramienta.modalValidacionHerramientas();
            },

            cambiarMultiplesTrts(){
                this.multiplesTrts = true

                //filtramos dientes sin padecimientos
                let padecimientos = this.formulario.dientes
                padecimientos = padecimientos.filter(p=>p.padecimiento != null)

                //ordenamos padecimientos
                let padecimientosOrdenados = padecimientos
                let dientes = padecimientosOrdenados.map(dior => dior.padecimiento.idPadecimiento);
                var length = dientes.length; 
                for (var i = 0; i < length; i++) {
                    for (var j = 0; j < (length - i - 1); j++) {
                        if(dientes[j] > dientes[j+1]) {
                            var tmp = dientes[j]; 
                            dientes[j] = dientes[j+1]; 
                            dientes[j+1] = tmp; 
                        }
                    }
                }

                //filtramos padecimientos repetidos
                let idFiltrado = dientes.filter((item,index)=>{
                    return dientes.indexOf(item) === index;
                })

                //armamos arreglo de padecimientos para multiples tratamientos
                this.formularioPadecimientos = [];
                idFiltrado.forEach(element => {
                    let objPadecimiento = {dientes: padecimientosOrdenados.filter(item => item.padecimiento.idPadecimiento == element), visiblePadecimiento: false, nombrePadecimiento: padecimientosOrdenados.filter(item => item.padecimiento.idPadecimiento == element)[0].padecimiento.descripcion, usado: false, seleccionado: false}
                    this.formularioPadecimientos.push(objPadecimiento)
                });
            },

            cancelar(){
                this.multiplesTrts = false
                this.multiTrt = true
            },

            guardarMultiplesTrts(item){
                this.multiTrt = true
                this.multiplesTrts = false
                item.forEach(element => {
                    element.padecimientos.forEach(padecimiento => {
                        this.formulario.dientes.forEach(diente => {
                            if(padecimiento.dientes.includes(diente.diente)){
                                let trtTemporal1 = [];
                                let trtTemporal2 = [];
                                element.tratamientos.forEach(trt => {
                                    trt.collapseOpen = false
                                });
                                trtTemporal1 = JSON.parse(JSON.stringify(element.tratamientos))
                                if(this.segundaOpcionCreada){
                                    trtTemporal2 = diente.tratamientos[1]
                                }

                                diente.tratamientos = [];
                                diente.tratamientos.push(trtTemporal1)
                                if(this.segundaOpcionCreada){
                                    diente.tratamientos.push(trtTemporal2)
                                }
                                
                            }
                        });
                    });
                });
            },

            cambioPadecimiento(){
                this.modificar = true;
                this.multiTrt = false;
                this.quitarSegundaOpcion = false;
                this.ordenarOds = false;
                this.segundaOpcionSeleccionada = 0;
            },

            ordenarCategoria(){
                let prioridad = this.formulario.dientes.filter(item=>{
                    return item.padecimiento.idClasificacionClinica == 1;
                })

                let hallazgo = this.formulario.dientes.filter(item=>{
                    return item.padecimiento.idClasificacionClinica == 2;
                })

                let sinClasificacion = this.formulario.dientes.filter(item=>{
                    return item.padecimiento.idClasificacionClinica == null;
                })

                this.formulario.dientes = []
                prioridad.forEach(element => {
                    this.formulario.dientes.push(element);
                });

                hallazgo.forEach(element => {
                    this.formulario.dientes.push(element);
                });

                sinClasificacion.forEach(element => {
                    this.formulario.dientes.push(element);
                });
            },

            obtenerInformacionHDX() {
                this.loading = true;
                const parametros = {idPaciente: this.idPaciente}
                this.$http.post(this.$api + "version5/ptipresuntivo/obtener/hdx/deserializado", parametros).then(
                    response => {
                        if(this.catTratamientos.length > 0){
                            this.loading = false;
                        }
                        this.formulario = Object.assign({}, response.data.data);
                        if (!this.formulario.diagnosticador) {
                            this.formulario.diagnosticador = this.$localStorageService.getNombreCompletoUsuario();
                        }
                        this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                        this.formulario.dientes.forEach(d => d.buscar = false);
                        this.tagCitaOriginal = this.formulario.idTagMotivoCita
                        this.id_denticion = response.data.data.idDenticion

                        let numOpciones = 0;
                        this.formulario.dientes.forEach(diente => {
                            numOpciones = diente.tratamientos.length
                        });

                        if(numOpciones == 2){
                            this.segundaOpcionCreada = true
                        }
                    }
                )
            },

            guardarNormal(){
                if(this.formulario.idTagMotivoCita == 6 || this.formulario.idTagMotivoCita == 13){
                    this.$swal.fire({
                        title:
                            "<strong>Para emitir el PTI debes de cambiar el motivo de cita a uno que no sea Dolor/Urgencia</strong>",
                        focusConfirm: false,
                        icon: "warning",
                        confirmButtonText: "ok",
                        customClass: {
                            confirmButton: "btn-success",
                        },
                    })
                    return;
                }
                if(!this.borrador && this.continuar){
                    var sinCategoria = false;
                    var sinTrt = false;
                    var txt = "";
                    var dientes = [];
                    var texto = "";
                    this.$v.formulario.$touch();
                        if (this.$v.formulario.$anyError) {
                        return;
                    }

                    this.datos(false, false).dientes.forEach(element => {
                        if(element.padecimiento.idClasificacionClinica == null || element.padecimiento.idClasificacionClinica == undefined){
                            sinCategoria = true;
                        }
                        var checkColumnUno = false;
                        var checkColumnDos = false;
                        var banderavalidacion = element.padecimiento.validacion
                            ? element.padecimiento.validacion
                            : false;
                        if(banderavalidacion){
                            element.tratamientos[0].forEach(trat => {
                                if(trat.idTratamiento != null || trat.idKit != null){
                                    checkColumnUno = true;
                                }
                            });
                            if(this.segundaOpcionCreada){
                                element.tratamientos[1].forEach(trat => {
                                    if(trat.idTratamiento != null || trat.idKit != null){
                                        checkColumnDos = true;
                                    }
                                });
                            }
                            if (
                                checkColumnUno == false &&
                                checkColumnDos == false
                            ) {
                                sinTrt = true;
                                txt = txt != "" ? txt + ", " + (element.diente.diente == 0 ? "SUPERNUMERARIO" : element.diente.diente) : (element.diente.diente == 0 ? "SUPERNUMERARIO" : element.diente.diente);
                                dientes.push(element.diente.diente == 0 ? "SUPERNUMERARIO" : element.diente.diente);
                            }
                        }
                    });

                    if (!this.$v.formulario.$invalid) {
                        if(sinCategoria){
                            this.$swal.fire({
                                icon: "info",
                                title: "Padecimiento sin categoría",
                                text: "Todos los padecimientos deben de tener una categoria asignada. por favor ingresala.",
                            }); 
                            return;
                        }else{
                            if(sinTrt){
                                texto = dientes.length > 1 ? "Los dientes " + txt + " No cuentan con 1 tx" : "El diente " + txt + " No cuenta con 1 tx.";
                                this.loading = false;
                                this.$swal.fire({
                                    icon: "info",
                                    title: "Falta agregar tratamientos",
                                    text: texto,
                                }); 
                                return;
                            }else{
                                this.$swal.fire({
                                    title:
                                        "<strong>¿Estás seguro de generar el PTI?</strong>",
                                    focusConfirm: false,
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí",
                                    cancelButtonText: "No",

                                    customClass: {
                                        confirmButton: "btn-primary",
                                        cancelButton: "btn-secondary",
                                    },
                                }).then((result) => {
                                    this.loading = false;
                                    if (result.isConfirmed) {
                                        this.formulario.tomaHerramienta = true;
                                        this.obtenerNivel();
                                    }
                                })
                            }
                        }
                    }
                }
            },
            
            guardarBorrador(){

              this.borrador = !this.borrador ? this.activoEnDiagnocat : this.borrador;

                if(this.borrador && this.continuar){
                    this.loading = true;
                    this.$http.post(this.$api + "version5/ptipresuntivo/guardar/borrador",this.datos(false, false)).then(
                        () => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Se guardó correctamente la información'
                            }).then(() => {
                                this.formulario = {
                                    fechaSolicitud: new Date().toLocaleString(),
                                    idClinica: null,
                                    clinica: null,
                                    idEmpleado: null,
                                    empleado: null,
                                    idFlujo: null,
                                    idTagMotivoCita: null,
                                    dientes: []
                                }
                                this.$router.push({name: "borradores"});
                            });
                        }
                    ).finally(
                        () => {
                            this.loading = false;
                        }
                    )
                }
            },

            obtenerNivel(){
                this.loading = true;
                this.$http.post(this.$api + "version5/ptipresuntivo/obtenerNivel", this.datos(false, false)).then((response) => {
                    this.nivelPTI = response.data.data
                }).finally(
                    () => {
                        this.loading = false;
                        this.enviarDatosAGuardar()
                    }
                )
            },

            async validacionActivarEceClinica() {
                const params = {
                    idFlujo: 1,
                    idPaciente: this.idPaciente, 
                    idClinica: this.$localStorageService.getIdClinica()
                }
                return await this.$http.post(
                    this.$api + "herramientaExpedienteElectronico/obtenerHerramientasFaltantes", params 
                );
            },

            datos(rev, cdx) {
                const datos = JSON.parse(JSON.stringify(this.formulario))
                datos.rutaExpediente = '';
                datos.idPaciente = this.idPaciente;
                datos.idDenticion = this.id_denticion;
                datos.descentralizado = this.descentralizado;
                datos.idEtapa = this.etapaRechazo;
                datos.idSolicitud = this.solicitudRechazo;
                datos.idSolicitudEtapa = this.idSolicitudEtapa;
                if(datos.idPti == null){
                    datos.idPti = this.idPti;
                }

                //Parche para enviar el pti y desactivar los padecimientos previos que se tenian debido al rechazo
                if (datos.idPti == null && this.idPtiRechazo != null) {
                  datos.idPti = this.idPtiRechazo;
                }

                datos.idFlujo = 3;
                datos.dientes.forEach(diente => {
                    const txs = [];
                    diente.tratamientos.forEach((item, index) => {
                        const tratamientosDiente = item.map((tx, i) => {
                            tx.orden = i;
                            tx.opcion = index + 1;
                            return tx
                        })
                        txs.push(tratamientosDiente);
                    });
                    diente.idDiente = diente.diente.idDiente
                    diente.tratamientos = txs;
                    diente.tratamientos.forEach((item,index)=> {
                        item.forEach(element => {
                            if(element.idKit != null){
                                element.listaTratamientos.forEach(lt => {
                                    lt.opcion = index + 1;
                                });
                            }
                        });
                    })
                })
                datos.revision = rev;
                datos.revisionEspecialista = cdx;
                datos.numero = this.numeroHerramientas;
                return datos;
            },

            enviarDatosAGuardar() {
                let nivel = "";
                if(this.nivelPTI == 1){
                    nivel = "Nivel I"
                }else if(this.nivelPTI == 2){
                    nivel = "Nivel II"
                }else if(this.nivelPTI == 3){
                    nivel = "Nivel III"
                }else if(this.nivelPTI == 4){
                    nivel = "Nivel IV"
                }

                this.loading = true
                //mandar a la bandeja de revision de pti
                this.$http.post(this.$api + "version5/ptipresuntivo/guardar/hdx", this.datos(false, false)).then((response) =>{
                  this.loading = false;
                  if(response.data.data > 0){
                    this.$swal.fire({
                      icon: 'success',
                      title: 'PTI ' + nivel + ' guardado exitosamente',
                      text: 'Este PTI es de ' + nivel + ', por lo que está listo para su presentación. Puedes revisarlo en la bandeja "Unidad de presentación".',
                      showCancelButton: true,
                      confirmButtonText: "Ir a bandeja",
                      cancelButtonText: "Cerrar",
                      customClass: {
                        confirmButton: 'rounded-pill',
                        cancelButton: 'rounded-pill'
                      },
                      allowOutsideClick: false,
                    }).then((aceptar) => {
                      this.formulario = {
                        fechaSolicitud: new Date().toLocaleString(),
                        idClinica: null,
                        clinica: null,
                        idEmpleado: null,
                        empleado: null,
                        idFlujo: null,
                        idTagMotivoCita: null,
                        dientes: []
                      }
                      if(aceptar.isConfirmed){
                        this.$router.push({name: "bandejaEmbajadorHallazgoV5"});
                      }
                      this.tienePti = false;
                      this.$emit('ptiCreado');
                    }).finally(() => {
                      this.loading = false;
                    });
                  }
                })
            },

            validacionOrtodoncia(){
              this.tieneBocaCompleta = false;
              let idsTratamientos = [];
              this.formulario.dientes.forEach(diente=>{
                diente.tratamientos.forEach(trt => {
                  trt.forEach(op=>{
                    if(op.idKit != null){
                      op.listaTratamientos.forEach(lt=>{
                        if(!idsTratamientos.includes(lt.idTratamiento)){
                          idsTratamientos.push(lt.idTratamiento);
                        }
                      })
                    }else{
                      if(!idsTratamientos.includes(op.idTratamiento)){
                        idsTratamientos.push(op.idTratamiento);
                      }
                    }
                  })
                })
                if(diente.diente.idDiente === 59){
                  this.tieneBocaCompleta = true;
                  this.padOrtodonciaPorOd = diente.padecimiento;
                  this.padOrtodonciaPorOd.modificado = true;
                }
              })

              this.$http.post(this.$api + "version5/ptipresuntivo/validarOrtodoncia", idsTratamientos).then((response) => {
                if (response.data.data){
                  this.validacionHerramientasModal()
                }else{
                  this.modalOrtodoncia = true;
                }
              })
            },

            eliminarKit(){
              this.trtOrtodoncia = [];
              this.tratamientosOrtodoncia = [];
              this.ortodonciaEliminada = true;
            },

            padOrtodonciaModificado(pad){
                this.padOrtodoncia = pad[0];
                this.padOrtodoncia.modificado = true;
            },

            clasificacionesClinicas(clasificacionClinica){
              this.opcionesClasificacionClinica = clasificacionClinica;
            },

            agregarTratamiento(){
              const item = {idTratamiento: null, cantidad: 1, modificado: true, collapseOpen: false, idKit: null}
              this.tratamientosOrtodoncia.push(JSON.parse(JSON.stringify(item)))
            },

            guardarOrtodoncia(){
              if(this.trtOrtodoncia.idKit === undefined){
                this.$swal.fire({
                  title:
                      "<strong>Falta agregar el kit de ortodoncia</strong>",
                  focusConfirm: false,
                  icon: "warning",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: "btn-primary",
                    cancelButton: "btn-secondary",
                  },
                })
                return;
              }
              let bocaCompleta = false;
              this.formulario.dientes.forEach(diente=>{
                if(diente.diente.idDiente === 59){
                  diente.tratamientos[0].push(this.trtOrtodoncia);
                  this.tratamientosOrtodoncia.forEach(to=>{
                    diente.tratamientos[0].push(to);
                  })
                  bocaCompleta = true;
                }
              })
              if (!bocaCompleta){
                let listaTratamientos = [];
                listaTratamientos.push(this.trtOrtodoncia);
                this.tratamientosOrtodoncia.forEach(to=>{
                  listaTratamientos.push(to);
                })
                let tratamientosOrtodonciaBocaCompleta = [];
                tratamientosOrtodonciaBocaCompleta.push(listaTratamientos);
                this.formulario.dientes.unshift({
                  diente: {diente: 'Boca completa', idDiente: 59, orden: 33},
                  buscar: true,
                  seleccionar: false,
                  visible: false,
                  padecimiento: this.tieneBocaCompleta ? this.padOrtodonciaPorOd : this.padOrtodoncia,
                  tratamientos: tratamientosOrtodonciaBocaCompleta,
                  visiblePadecimiento: false
                });
              }
              this.dientesSeleccionados.push({diente: 'Boca completa', idDiente: 59, orden: 33})
              this.modificar = false;
              this.modalOrtodoncia = false;
              this.validacionHerramientasModal();
            },

            eliminarTratamiento(item) {
              this.tratamientosOrtodoncia.splice(this.tratamientosOrtodoncia.indexOf(item), 1)
            },

            mostrarOcultarTrtKits(){
              this.trtOrtodoncia.isOpen = !this.trtOrtodoncia.isOpen;
            },

            tagSeleccionadoEnLaCita() {
                this.tagSeleccionadoEnLaCitaArray = [];
                const params = {
                    idSesion: this.formulario.idSesion
                }
                this.$http.post(this.$api + "tagmotivocita/poridsesion", params).then((response) => {
                    this.tagSeleccionadoEnLaCitaArray = response.data.data;

                    if (this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita != null) {
                        this.formulario.idTagMotivoCita = this.tagSeleccionadoEnLaCitaArray.idTagMotivoCita;
                        this.formulario.idFlujo = 3;
                        
                        this.formulario.idFlujoPx1 = this.tagSeleccionadoEnLaCitaArray.idTipoTag;
                        this.tag = this.tagSeleccionadoEnLaCitaArray.descripcionTagMotivoCita;
                    }
                    this.tagMotivoCita();
                });
            },

            obtenerBorrador() {
                const params = {
                    idPaciente: this.idPaciente
                }
                this.$http.post(this.$api + "version5/ptipresuntivo/obtener/borrador", params).then(
                    res => {
                        if (res.data.data != null){
                            this.formulario = res.data.data;
                            this.dientesSeleccionados = this.formulario.dientes.map(d => d.diente);
                            this.borradorExistente = true
                        }
                    }
                )
            },

            //Metodos temporales mientras no hay menu lateral
            obtenerCita(){
                const params = {
                    idSesion: this.idSesionSeleccionada
                }
                this.$http.post(this.$api + "version5/ptipresuntivo/obtenerCita", params).then((response) => {
                    this.idCitaPaciente = response.data.data;
                })
            },

            existePti() {
                const parametros = {idPaciente: this.idPaciente}
                this.$http.post(this.$api + "pti/existePtiMayor6Meses", parametros).then((response) => {
                    this.tienePti = response.data.data;
                })
                .catch((error) => {
                    console.error(
                        "Error al obtener la validación de existencia de un pti del  del paciente: " +
                        error
                    );
                })
            },

            tagMotivoCita() {
                this.tagmotivocitaDatosArrayOriginal = [];
                this.$http.get(this.$api + "tagmotivocita/tagmotivocita").then((response) => {
                    this.tagmotivocitaDatosArrayOriginal = response.data.data.filter(r => r.idTipoDenticion === this.id_denticion);
                    let tagMotivoCit = response.data.data.filter(r => (r.idTipoDenticion === this.id_denticion) && (this.tag === r.descripcionTagMotivoCita));
                    if(tagMotivoCit.length > 0){
                        this.cambioTag = tagMotivoCit[0]
                    }
                })
            },

          async obtenerClinicaDiagnocat() {

            return await this.$http
                .post(
                    this.$api +
                    "diagnocat/validarClinica",{"idClinica":this.$localStorageService.getIdClinica()}
                )
                .then((response) => {
                  this.activoEnDiagnocat = response.data.data;
                }).finally(()=>{
                  if (this.activoEnDiagnocat){
                    this.$http.post(this.$api + "padecimientoTipoAgrupacion/obtenerPadecimientosConAgrupacion").then((response) => {
                      this.padecimientosConAgrupaciones = response.data.data;
                    })
                    this.autoguardadoDiagnoEce();
                  }
                })

          },
          autoguardadoDiagnoEce(){
            this.$http.post(this.$api + "diagnocat/autoguardadoExpedienteClinicoElectronicoDiagnocat",{"idPaciente":this.idPaciente}).then((response) => {
              response.data.data
            }).finally(
                () => {
                }
            )
          },
        },
    }
</script>

<style scoped>
.tituloHC{
    font-weight: bold;
    font-size: 1em;
    color: #0069A9;
}

.subTituloHC{
    font-weight: 600;
    font-size: .95em;
    color: #53BACA;
}

.opcionesPopover{
  font-size: .9em;
  color: #0069aa;
}

.scrollable-container-hdx {
    overflow-y: auto;
    max-height: 62vh;
}

.nombre-completo-paciente {
  font-size: .9em !important;
  font-weight: 500;
  color: #717171;
}

.container-nombre {
  display: flex;
  justify-content: center;
}

.row-nombre {
  width: 50%; 
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 29px;
  margin-left: 3px;
  margin-right: 3px;
  margin-bottom: 2px;
}

.marginbotones{
  border-radius:20px;
}

.tamanio-botones {
  width: 35px;
  height: 35px;
}

.tamanio-iconos {
  width: 17px;
  height: 17px;
}

.paddingbotones {
  padding-top: 4px;
  padding-bottom: 0px;
  padding-left: 8px;
  padding-right: 5px;
}
</style>
